import { componentClasses } from "../../../core/components/tooltip/tooltip";

const Template = (args) => {
    const trigger = args.trigger ? `${args.trigger}` : "tooltip";
    const id = args.id || "tooltip-0";
    return `
    <div
        id="${id}"
        data-trigger="#${trigger}" 
        data-dds="tooltip"
        class="${componentClasses.tooltip}"
        role="tooltip"
    >
        <div class="${componentClasses.body}">
            ${
                args.title
                    ? `
            <h6 class="${componentClasses.title}">${args.title}</h6>`
                    : ""
            }
            ${args.body}
        </div>
    </div>`;
};

export default Template;
